import React, { useState, useContext } from "react";
import { SettingsContext } from "./AccountSettingsButton";
import jsDig from "utils/jsDig.js";
import CustomTooltip from "utils/CustomTooltip";

export default function GoogleAdsCustomConversions() {
  const context = useContext(SettingsContext);
  const [customConversionsEnabled, setCustomConversionsEnabled] = useState(context.googleAdsCustomConversionsEnabled);
  const [customConversions, setCustomConversions] = useState(context.googleAdsCustomConversions || []);

  const handleCheckboxChange = (event) => {
    setCustomConversionsEnabled(event.target.checked);
    context.setGoogleAdsCustomConversionsEnabled(event.target.checked);
  };

  const addCustomConversion = () => {
    setCustomConversions([...customConversions, { conversion_type: "inclusive", name: "", conversion_id: "" }]);
    context.setGoogleAdsCustomConversions([...customConversions, { conversion_type: "inclusive", name: "", conversion_id: "" }]);
  };

  const deleteCustomConversion = (index) => {
    const newCustomConversions = customConversions.filter((_, i) => i !== index);
    setCustomConversions(newCustomConversions);
    context.setGoogleAdsCustomConversions(newCustomConversions);
  };

  const handleCustomConversionChange = (index, field, value) => {
    const newCustomConversions = customConversions.map((customConversion, i) => {
      if (i === index) {
        return { ...customConversion, [field]: value };
      }
      return customConversion;
    });
    setCustomConversions(newCustomConversions);
    context.setGoogleAdsCustomConversions(newCustomConversions);
  };

  return (
    <div className="google-ads-custom-conversions-inner">
      <div className="lite-checkbox-container">
        <input
          type="checkbox"
          className="lite-checkbox"
          id="google_ads_custom_conversions"
          name="google_ads_custom_conversions[enabled]"
          onChange={handleCheckboxChange}
          checked={customConversionsEnabled}
        />
        <label htmlFor="google_ads_custom_conversions">
          Customize conversions?
          <CustomTooltip
            faClass="far fa-question-circle pl-2"
            message="By default DataPulse will pull 'Conversions' from Google Ads. If you would like to choose which conversions to pull, enable this option and add rules below. You can choose to exclude or include specific conversions based on their ID. To get a conversion's ID, go to Google Ads > Goals > Conversions > Summary and click on the conversion you want to pull. The ID will be in the URL (the text that comes after ctId=)."
            inline={true}
          />
        </label>
      </div>
      {customConversionsEnabled && (
        <div className="custom-conversions-container">
          {customConversions.map((customConversion, index) => (
            <div key={index} className="google-ads-custom-conversion">
              <div className="select-wrapper">
                <select value={customConversion.conversion_type} onChange={(e) => handleCustomConversionChange(index, "conversion_type", e.target.value)}>
                  <option value="inclusive">Include</option>
                  <option value="exclusive">Exclude</option>
                </select>
              </div>
              <input type="text" placeholder="Label" value={customConversion.name} onChange={(e) => handleCustomConversionChange(index, "name", e.target.value)} />
              <input type="text" placeholder="ID" value={customConversion.conversion_id} onChange={(e) => handleCustomConversionChange(index, "conversion_id", e.target.value)} />
              <button className="lite-btn btn-secondary" type="button" onClick={() => deleteCustomConversion(index)}>Delete</button>
            </div>
          ))}
          <button className="lite-btn btn-primary" type="button" onClick={addCustomConversion}>Add Rule</button>
        </div>
      )}
    </div>
  );
}
